import i18n from 'Lib/i18n'

export const PRODUCT_PLATFORMS = {
  paidMarketing: [{ name: 'google' }, { name: 'meta' }, { name: 'microsoft' }],
  botZapping: [{ name: 'wordpress' }],
}

export const getTooltipTextByBooleans = (
  enabled: boolean | undefined,
  connected: boolean | undefined
) => {
  if (enabled && connected) {
    return i18n.t('connection_statuses.enabled', { ns: 'home' })
  }
  if (!enabled && connected) {
    return i18n.t('connection_statuses.connected', { ns: 'home' })
  }
  return i18n.t('connection_statuses.not_connected', { ns: 'home' })
}

export const getTooltipByStatus = (status?: string) => {
  switch (status) {
    case 'enabled':
      return i18n.t('connection_statuses.enabled', { ns: 'home' })
    case 'connected':
      return i18n.t('connection_statuses.connected', { ns: 'home' })
    default:
      return i18n.t('connection_statuses.not_connected', { ns: 'home' })
  }
}

export const getStatusStringByBooleans = (
  enabled: boolean | undefined,
  connected: boolean | undefined
) => {
  if (enabled && connected) {
    return 'enabled'
  }
  if (!enabled && connected) {
    return 'connected'
  }
  return undefined
}
